
import { defineComponent, computed, onMounted, nextTick } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { GlobalDataProps } from '../store/index'
import { TemplateProps } from '../store/templates'
import { generateQRCode, downloadImage } from '../helper'
export default defineComponent({
  setup() {
    const route = useRoute()
    const router = useRouter()
    const store = useStore<GlobalDataProps>()
    const currentId = route.params.id as string
    const template = computed<TemplateProps>(() => store.getters.getTemplateById(parseInt(currentId)))
    const channelURL = computed(() => `${process.env.VUE_APP_H5_URL}/pages/${template.value.id}-${template.value.uuid}`)
    onMounted(async () => {
      await store.dispatch('fetchTemplate', { urlParams: { id: currentId } })
      await nextTick()
      await generateQRCode('barcode-container', channelURL.value, 150)
    })
    const download = () => {
      downloadImage(template.value.coverImg)
    }

    async function copyWork() {
      try {
        const { data } = await store.dispatch('copyWork', { urlParams: { id: currentId } })
        console.log('data', data)

        router.push({ name: 'EditorWork', params: { id: data.id } })
      } catch (error) {
        console.error(error)
      }
    }

    return {
      route,
      template,
      download,
      copyWork
    }
  }
})
